import { EMPTY_OBJECT, EMPTY_STRING } from '../../../../constants/common'
import { getEntityProfileTabUpdateOwner } from '../../../Entity'

import {
  VIEWING_UPDATE_ACTION,
  VIEWING_UPDATE_ACTION_TRANSLATION_KEY,
} from './RentalPortalViewingProfileUpdates.constants'

function getViewingUpdateValues(item) {
  const data = item?.data || EMPTY_OBJECT

  switch (item?.action) {
    case VIEWING_UPDATE_ACTION.create:
      return { unit: data.unit ?? EMPTY_STRING }
    case VIEWING_UPDATE_ACTION.book:
      return { applicant: data.applicant ?? EMPTY_STRING }
    default:
      return EMPTY_OBJECT
  }
}

function getViewingUpdateText({ item, t }) {
  const key = VIEWING_UPDATE_ACTION_TRANSLATION_KEY[item?.action]

  return key ? t(key, getViewingUpdateValues(item)) : EMPTY_STRING
}

export function toTranslatedViewingUpdates({ items, t }) {
  return items.map(item => ({
    ...item,
    owner_obj: getEntityProfileTabUpdateOwner(item.initiated_by),
    text: getViewingUpdateText({ item, t }),
    timestamp: item.event_dt,
  }))
}
